@if (subscriptionData$ | async; as data) {
  <div>
    @if (
      data.appSubscriptionState === appSubscriptionState.active && activeFeatures() && !activeFeatures().flags.base
    ) {
      <div>
        <h6 class="alert-heading card-heading">
          <i class="fa fa-info-circle me-1"></i>{{ 'customer_plan_contact_sales.user_is_deactivated' | translate }}
        </h6>
        <p class="mb-0">{{ 'customer_plan_contact_sales.contact_your_adminitstrator' | translate }}<br /></p>
        <p class="mb-0" [innerHTML]="'customer_plan_contact_sales.contact_enin_support' | translate"></p>
      </div>
    }
    @if (data.appSubscriptionState === appSubscriptionState.trial) {
      <div
        class="alert"
        [class.alert-info]="data.daysUntilTermEnds >= 5"
        [class.alert-warning]="data.daysUntilTermEnds < 5">
        <h6 class="alert-heading card-heading">
          <span
            [innerHTML]="
              'customer_plan_contact_sales.days_left_trail' | translate: { daysUntilTermEnds: data.daysUntilTermEnds }
            "></span>
        </h6>

        <p class="mb-0">
          {{ 'customer_plan_contact_sales.are_you_happy_with_trial' | translate }}<br />
          <span [innerHTML]="'customer_plan_contact_sales.contact_sales_or_send_mail' | translate"></span>
        </p>
      </div>
    }

    @if (data.appSubscriptionState === appSubscriptionState.cancelled) {
      <div class="alert alert-warning">
        <h6 class="alert-heading card-heading">
          {{ 'customer_plan_contact_sales.plan_is_expired_or_canceled' | translate }}
        </h6>
        <p class="mb-0">{{ 'customer_plan_contact_sales.do_you_wish_to_setup_payment' | translate }}<br /></p>
        <p class="mb-0" [innerHTML]="'customer_plan_contact_sales.contact_sales_or_send_mail' | translate"></p>
      </div>
    }

    @if (data.appSubscriptionState === appSubscriptionState.grace_period) {
      <div class="alert alert-warning">
        <h6 class="alert-heading card-heading">
          {{
            'customer_plan_contact_sales.plan_is_in_grace_period'
              | translate: { gracePeriodEndDate: data.gracePeriodEndDate | date: 'mediumDate' }
          }}
        </h6>
        <p class="mb-0">{{ 'customer_plan_contact_sales.renew_subscription_to_continue' | translate }}<br /></p>
        <p class="mb-0" [innerHTML]="'customer_plan_contact_sales.contact_sales_or_send_mail' | translate"></p>
      </div>
    }
  </div>
}
